{
  "type": "object",
  "name": "voucher",
  "class": "py-4",
  "definitions": [
    {
      "type": "group",
      "control": "div",
      "title": "Belegdaten",
      "definitions": [
        {
          "type": "date",
          "title": "",
          "name": "belegdatum",
          "class": "color-light",
          "filter": { "title": "Belegdatum" },
          "sortable": { "title": "Belegdatum" }
        },
        {
          "type": "entity",
          "title": "",
          "name": "konto",
          "endpoint": "",
          "format": "{{number}} - {{name}}",
          "class": "font-bold text-lg",
          "filter": { "title": "Konto" },
          "sortable": { "title": "Konto" }
        },
        {
          "type": "string",
          "title": "Belegnummer: ",
          "name": "belegnummer",
          "filter": { "title": "Belegnummer" },
          "sortable": { "title": "Belegnummer" }
        },
        {
          "type": "entity",
          "title": "Objekt: ",
          "name": "objekt",
          "endpoint": "",
          "format": "{{objekt}} - {{bezeichnung}}",
          "filter": { "title": "Objekt" },
          "sortable": { "title": "Objekt" },
          "visible": {
            "name": "property",
            "property": "objekt",
            "rule": {
              "name": "not",
              "rule": {
                "name": "empty"
              }
            }
          }
        }
      ]
    },
    {
      "type": "currency",
      "title": "Netto",
      "name": "gesamt",
      "codeName": "currency",
      "filter": true,
      "sortable": true,
      "class": [
        {
          "class": "text-balance-negative",
          "rule": {
            "name": "property",
            "property": "gesamt",
            "rule": {
              "name": "number",
              "maxValue": 0
            }
          }
        }
      ]
    }
  ]
}
